import { router, setPageContent } from "..";
import { registerFencealarm } from "../api/users_{userId}_fencealarm";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerFencealarmPage() {
	const scan = () => {
		scanBarcode(t.fencealarm.addDevicePage.scanImeiBarcodePrompt).then(
			(code) => {
				if (!code) return;
				imei.setValue(code);
			},
		);
	};

	const imei = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(t.fencealarm.addDevicePage.header, "is-4"),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () => window.open(t.supportUrl, "_blank"),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMEI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imei.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: scan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(t.device.addDevicePage.chooseNamePrompt),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						t.add,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						t.back,
					),
				),
			),
		),
	);

	function onClickRegister() {
		const attempt = errorSection.attempt(async () => {
			const fa = await registerFencealarm(
				imei.getValue(),
				name.getValue(),
			);
			state.fencealarms[fa.Imei] = fa;
			router.jump(`/devices?id=${fa.Imei}`);
		});
		loadingScreen.waitFor(attempt);
	}
}

export { registerFencealarmPage };
